export default __webpack_public_path__ + "static/media/template4.e871a6d5.png";